import { AccountBoxSharp } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralTeamSales = {
    id: 'ambassadorDeposit',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'ambassadorDeposit',
            title: 'Ambassador Deposit',
            type: 'item',
            url: '/ambassadorDeposit',
            icon: AccountBoxSharp,
            breadcrumbs: false
        }
    ]
};

export default referralTeamSales;
